module.exports = __webpack_public_path__ + "static/media/empty2.4ff39742.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/empty2.png
// module id = 351
// module chunks = 0